export enum WeatherReportSeverityEnum {
  rain = "rain",
  mixedPrecipitation = "mixedPrecipitation",
  lightSnow = "lightSnow",
  moderateSnow = "moderateSnow",
  heavySnow = "heavySnow",
  noPrecipitation = "noPrecipitation",
}

export const weatherReportSeverityTitleMap: Record<
  WeatherReportSeverityEnum,
  string
> = {
  [WeatherReportSeverityEnum.rain]: "Rain",
  [WeatherReportSeverityEnum.mixedPrecipitation]: "Mixed Precipitation",
  [WeatherReportSeverityEnum.lightSnow]: "Light Snow",
  [WeatherReportSeverityEnum.moderateSnow]: "Moderate Snow",
  [WeatherReportSeverityEnum.heavySnow]: "Heavy Snow",
  [WeatherReportSeverityEnum.noPrecipitation]: "No Precipitation",
};

export const weatherSeverityValues = Object.values(WeatherReportSeverityEnum);
